// extracted by mini-css-extract-plugin
export default {"container":"o5nSeiT2"};